import React from "react"
import HeaderSectionLeft from "./HeaderSectionLeft.jsx"
import HeaderSectionRight from "./HeaderSectionRight.jsx"
import CMSData from "aldoo-ra/CMS/cms-data"

const HeaderSection = () => {
  //Load the data for the section from the CMS
  const { data, loading } = CMSData({
    contentType: "PageSection",
    match: { "content.name": "AndroidLandingHeader" },
  })

  if (loading || !data || !data.length) return null

  const sectionData = data[0]
  if (!sectionData) return null

  return (
    <div>
      <div className="relative flex flex-col md:flex-row w-full md:max-w-[900px] lg:max-w-[1060px] xl:max-w-[1530px] justify-between items-center md:items-start gap-12 md:gap-6 pt-8 md:pt-0 lg:pt-8 xl:pt-0 px-6 lg:px-8 mb-10 md:mb-[96px] lg:mb-[138px] mx-auto">
        <HeaderSectionLeft data={sectionData} />
        <HeaderSectionRight data={sectionData} />
      </div>
    </div>
  )
}

export default HeaderSection
